/* eslint-disable id-length */
// library imports
import Vue from "vue";
import router from "./router";
import VueI18n from "vue-i18n";
import VueSweetalert2 from "vue-sweetalert2";
import VueMultianalytics from "vue-multianalytics";

// plugins
import SharedComponents from "./sharedComponents";
import App from "./App.vue";
import Api from "./services/Api";
import Translations from "./translations/translations";
import SessionService from "./services/session";
import Utils from "./utils";
import Amplify from "@aws-amplify/core";
import VCalendar from "v-calendar";
import moment from "moment";
import LogRocket from "logrocket";
import "@/setup/vee-validate.js";
import store from "@/store";
import InfiniteLoading from "vue-infinite-loading";

// import only moment locals that are used
import "moment/locale/de.js";
import "moment/locale/fr.js";

// library imports
import "sweetalert2/dist/sweetalert2.css";

// styles
import "./assets/sass/app.scss";

// custom filters
import "./filters";

// config
import EnvironmentConfig from "./EnvironmentConfig";

Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(SharedComponents);
Vue.use(VueSweetalert2);
Vue.use(InfiniteLoading, {
	props: {spinner: "spiral", },
	slots: {
		// remove default messages when no results
		noResults: "",
		noMore: "",
	}
});

moment.updateLocale("en", {
	relativeTime: {
		ss: `%d${Translations.en.relative_times.seconds}`,
		mm: `%d${Translations.en.relative_times.minutes}`,
		hh: `%d${Translations.en.relative_times.hours}`,
		dd: `%d${Translations.en.relative_times.days}`,
		MM: `%d${Translations.en.relative_times.months}`,
		yy: `%d${Translations.en.relative_times.years}`
	}
});

moment.updateLocale("fr", {
	relativeTime: {
		ss: `%d${Translations.fr.relative_times.seconds}`,
		mm: `%d${Translations.fr.relative_times.minutes}`,
		hh: `%d${Translations.fr.relative_times.hours}`,
		dd: `%d${Translations.fr.relative_times.days}`,
		MM: `%d${Translations.fr.relative_times.months}`,
		yy: `%d${Translations.fr.relative_times.years}`
	}
});

moment.updateLocale("de", {
	relativeTime: {
		ss: `%d${Translations.de.relative_times.seconds}`,
		mm: `%d${Translations.de.relative_times.minutes}`,
		hh: `%d${Translations.de.relative_times.hours}`,
		dd: `%d${Translations.de.relative_times.days}`,
		MM: `%d${Translations.de.relative_times.months}`,
		yy: `%d${Translations.de.relative_times.years}`
	}
});

Vue.use(VCalendar, {firstDayOfWeek: 2});

Vue.use(VueMultianalytics, {
	modules: {
		mixpanel: {
			token: "a007f01e8811fb9860fd0acfe2405f2b",
			debug: process.env.NODE_ENV !== "production"
		}
	},
	routing: {
		vueRouter: router, //  Pass the router instance to automatically sync with router (optional)
		// preferredProperty: 'name', // By default 'path' and related with vueRouter (optional)
		// ignoredViews: ['homepage'], // Views that will not be tracked
		// ignoredModules: ['ga'] // Modules that will not send route change events.
	}
});

export const EventBus = new Vue(),
	i18n = new VueI18n({
		// set locale
		locale: localStorage.getItem("language"),
		fallbackLocale: "en",
		// set locale messages
		messages: Translations,
		silentTranslationWarn: true
	}),
	ApiService = new Api();

Vue.prototype.$eventBus = EventBus;
Vue.prototype.$api = ApiService;
Vue.prototype.$sessionService = SessionService;
Vue.prototype.$utils = Utils;
Vue.prototype.$moment = moment;
Vue.prototype.$localStorage = localStorage;

SessionService.init(router);

Amplify.configure({
	Auth: {
		mandatorySignIn: true,
		region: "EU_CENTRAL_1",
		userPoolId: EnvironmentConfig.userPoolId,
		userPoolWebClientId: EnvironmentConfig.userPoolWebClientId
	}
});

LogRocket.init("t04enf/kitro-sa", {
	// log only warn and error
	console: {
		log: false,
		info: false,
		debug: false,
		warn: false,
		error: true
	},
	// aggregate same errors into one entry
	shouldAggregateConsoleErrors: true,
	// hide log rocket presence from dev console
	shouldDebugLog: false
});

new Vue({
	router,
	i18n,
	store,
	render: createElement => createElement(App),
	mounted() {
		window.addEventListener("storage", storageEventHandler, false);

		function storageEventHandler(event) {
			if (event.key.startsWith("CognitoIdentityServiceProvider")) {
				const EMPTY = 0;
				if (localStorage.length === EMPTY)
					router.push({path: "/sign-in"});
				else
					router.push({path: "/"});

			}
		}
	}

}).$mount("#app");
